<template>
	<div class="top">
		<div class="userInfo">
			<img src="../images/home/logo.png" class="logo" alt="" />
			<div class="info">
				<div class="user" @click="gotoCenter">
					<div v-if="isLogin" class="log">
						<span @click.stop="showLonginPanel">登录</span>
						| <span @click.stop="showLonginPanel">注册</span>
					</div>
					<!-- <div v-if="!isLogin"> -->
					<img :src="headimage" alt="" srcset="" />
					<span v-if="!isLogin"
						>欢迎你，{{ Info.name }}&nbsp;&nbsp;|&nbsp;&nbsp;
						<p @click.stop="exit" style="display: inline-block">退出登录</p>
					</span>
					<!-- </div> -->
				</div>
				<div class="search"></div>
				<div v-if="showLogin" class="shadow">
					<Login />
				</div>
			</div>
		</div>
		<div class="menu">
			<router-link to="/home" :class="choosePath == '/home' ? 'choose' : ''">首页</router-link>
			<router-link to="/zyAct" :class="choosePath == '/zyAct' ? 'choose' : ''">活动招募</router-link>
			<router-link to="/PractActivies" :class="choosePath == '/PractActivies' ? 'choose' : ''">文化泉州</router-link>
			<router-link to="/exchangeList" :class="choosePath == '/exchangeList' ? 'choose' : ''">文明积分</router-link>
			<router-link to="/CivilizedPractice" :class="choosePath == '/CivilizedPractice' ? 'choose' : ''"
				>文明实践</router-link
			>
			<!-- <router-link to="/CivilizedPractice" :class="choosePath == '/CivilizedPractice' ? 'choose' : ''"></router-link> -->
			<a href="https://www.qzwmsj.com/organizationEntry/submit.html">组织入驻</a>
			<!-- </router-link> -->
		</div>
	</div>
</template>
<script>
import Login from '@/components/Login.vue'
import api from '@/assets/api.js'

export default {
	components: {
		Login
	},
	name: 'Myheader',
	data() {
		return {
			// menu: [
			//   {
			//     id: 1,
			//     name: "首页",
			//     path: "/home",
			//   },
			//   {
			//     id: 2,
			//     name: "四单服务",
			//     path: "/zyAct",
			//   },
			//   {
			//     id: 3,
			//     name: "活动招募",
			//     path: "/zyAct",
			//   },
			//   {
			//     id: 4,
			//     name: "培训资料",
			//     path: "/zyAct",
			//   },
			//   {
			//     id: 5,
			//     name: "文明实践",
			//     path: "/zyAct",
			//   },
			//   {
			//     id: 6,
			//     name: "实践活动",
			//     path: "/zyAct",
			//   },
			//   {
			//     id: 7,
			//     name: "实践动态",
			//     path: "/PractActivies",
			//   },
			// ],

			choosePath: '',
			showLogin: false,
			isLogin: true,
			Info: '',
			userName: '',
			headimage: require('../images/home/userIcon.png')
		}
	},
	watch: {
		$route(to, from) {
			if (
				to.path == '/home' ||
				to.path == '/zyAct' ||
				to.path == '/PractActivies' ||
				to.path == '/CivilizedPractice' ||
				to.path == '/exchangeList' ||
				to.path == 'register'
			) {
				this.choosePath = to.path
			}
		}
	},
	mounted() {
		let that = this

		this.$EventBus.$on('hideLogin', (path) => {
			that.showLogin = false
		})
		// 通过这个事件来进行登录完成后的数据的刷新
		this.$EventBus.$on('hasLogin', (path) => {
			const zyzid = localStorage.getItem('qz_zyz_zyzid')
			if (zyzid) {
				that.isLogin = false
				that.getUserInfo(zyzid)
			}
		})
		const zyzid = localStorage.getItem('qz_zyz_zyzid')
		if (zyzid) {
			that.isLogin = false
			that.getUserInfo(zyzid)
		}
	},
	methods: {
		gotoCenter() {
			if (!localStorage.getItem('qz_zyz_zyzid')) {
				this.$message.error('请先登录')
				return
			}
			{
				this.$router.push({ path: 'personalCenter' })
			}
		},
		showLonginPanel() {
			this.showLogin = true
		},
		getUserInfo(zyzid) {
			let that = this
			let params = {
				zyzid: zyzid
			}
			api.post('/api/volunteer/info.do', params).then(function (res) {
				let { data, errCode } = res
				if (errCode == '0000') {
					that.Info = data
					that.userName = that.Info.name
					that.headimage = that.Info.headimage
					that.$EventBus.$emit('hideLogin', '')
				} else {
					that.isLogin = true
				}
			})
		},
		exit() {
			this.isLogin = true
			this.userName = ''
			this.headimage = ''
			this.headimage = require('../images/home/userIcon.png')
			localStorage.removeItem('qz_zyz_token')
			localStorage.removeItem('qz_zyz_zyzid')

			// localStorage.clear()
		}
	}
}
</script>
<style scoped lang="less">
.shadow {
	background-color: rgba(4, 4, 4, 0.3);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 12;
}
.top {
	width: 100%;
	background: url('https://file2.zyh365.com/policy/quanzhou_gw_bg.png') no-repeat;
	background-size: 100%;
}
.userInfo {
	height: 13.33vh;
	padding: 0 18.75vw;
	display: flex;
	justify-content: space-between;
}
.logo {
	width: 19.73vw;
	height: 10.37vh;
	margin-top: 1.48vh;
	object-fit: contain;
}
.info {
	margin-top: 2.96vh;
	cursor: pointer;
}
.user {
	display: flex;
	align-items: center;
	font-size: 1.296vh;
	font-family: MicrosoftYaHei;
	color: #333333;
	line-height: 1.851vh;
}
.user > img {
	width: 2.5vw;
	height: 2.5vw;
	margin-right: 0.416vw;
	margin-left: 0.416vw;
}
.menu {
	width: 100%;
	height: 5.92vh;
	padding: 0 18.75vw;
	display: flex;
	box-sizing: border-box;
	background: #d7382f;
}
.menuUl {
	display: flex;
	align-items: center;
	height: 100%;
	margin: 0;
	padding: 0;
}

a {
	font-size: 1.851vh;
	font-family: MicrosoftYaHei;
	color: #ffffff;
	height: 100%;
	display: flex;
	align-items: center;
	/* width: 100%; */
	justify-content: center;
}
/* 首页 活动招募 实践动态 */
a {
	width: 10.41vw;
	text-align: center;
}
.choose {
	background: #ffffff;
	font-size: 1.851vh;
	font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
	font-weight: bold;
	color: #d7382f;
	justify-content: center;
	height: 100%;
}
</style>
